import { makeStyles } from 'tss-react/mui';

const useStylesEnvironmentBanner = makeStyles()((theme) => {
    return {
        banner: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: theme.spacing(1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        staging: {
            backgroundColor: '#f6a609',
            background: `
                linear-gradient(to right, #f8f8f8, transparent 30%, transparent 70%, #f8f8f8),
                repeating-linear-gradient(45deg, #f6a609, #f6a609 10px, #f9b233 10px, #f9b233 20px)
            `,
        },
        development: {
            backgroundColor: '#2196f3',
            background: `
                linear-gradient(to right, #f8f8f8, transparent 30%, transparent 70%, #f8f8f8),
                repeating-linear-gradient(45deg, #2196f3, #2196f3 10px, #42a5f5 10px, #42a5f5 20px)
            `,
        },
        text: {
            color: 'white',
            fontWeight: 600,
            fontSize: '8px !important',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
        },
    };
});

export default useStylesEnvironmentBanner;
